import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { settingsService } from '../services/api';

interface BrandingData {
  branding_nome: string;
  branding_subtitulo: string;
  branding_logo: string;
  branding_favicon: string;
}

interface BrandingContextType {
  branding: BrandingData;
  refreshBranding: () => Promise<void>;
  isLoading: boolean;
}

const defaultBranding: BrandingData = {
  branding_nome: 'NeoGestor',
  branding_subtitulo: 'Plataforma de Governanca de Indicadores',
  branding_logo: '',
  branding_favicon: '',
};

const BrandingContext = createContext<BrandingContextType>({
  branding: defaultBranding,
  refreshBranding: async () => {},
  isLoading: true,
});

export const BrandingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [branding, setBranding] = useState<BrandingData>(defaultBranding);
  const [isLoading, setIsLoading] = useState(true);

  const fetchBranding = useCallback(async () => {
    try {
      const data = await settingsService.getBranding();
      setBranding({ ...defaultBranding, ...data });
    } catch {
      // Usar defaults se falhar
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBranding();
  }, [fetchBranding]);

  // Atualizar favicon dinamicamente
  useEffect(() => {
    if (branding.branding_favicon) {
      const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (link) {
        link.href = branding.branding_favicon;
      }
    }
    if (branding.branding_nome) {
      document.title = branding.branding_nome;
    }
  }, [branding.branding_favicon, branding.branding_nome]);

  return (
    <BrandingContext.Provider value={{ branding, refreshBranding: fetchBranding, isLoading }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
